export type Recipient = Readonly<{
    id: string; // some internal unique identifier, eg. a UUID
    email: string; // the contact information for that recipient. Theoretically this could also be fax number.
    deletable: boolean; // Entries added by the user should be deletable
    editable: boolean; // Pre-filled CSE mail address cannot be edited
    selected: boolean; // Selected entries will receive the report; pre-selected are entries from the notification
    defaultEmail: boolean; // Is set to true for mandatory recipients like CSE email
}>;

export const initialRecipientState: Recipient = {
    id: '',
    email: '',
    deletable: true,
    editable: true,
    selected: true,
    defaultEmail: false,
};
